import { Injectable } from '@angular/core';
import { Time } from '@angular/common';

  export class BatchArry {
    customer: string;
    pickUpDate: string;
    pickUpTime: string;
    dropOffDate: string;
    dropOffTime: string;
    stopsAddress: string;
    pickUpAddress: string;
    pickUpInstructions: string;
    dropOffAddress: string;
    numberOfPeople: string;
    dropOffInstructions: string;
    emailAddress: string;
  }

  export class PostIt {
    SessionID: string;
    Trip: BatchArry[];
  }

  const batchArry: BatchArry[] = [
    {
      'customer' : '',
      'pickUpDate' : '',
      'pickUpTime' : '',
      'dropOffDate' : '',
      'dropOffTime' : '',
      'stopsAddress' : '',
      'pickUpAddress' : '',
      'pickUpInstructions' : '',
      'dropOffAddress' : '',
      'numberOfPeople' : '',
      'dropOffInstructions' : '',
      'emailAddress' : ''
  }
];

    @Injectable()
    export class ArrService {
      getBatcharr() {
        return batchArry;
      }
    }


